module.exports = __webpack_public_path__ + "img/policyService.9850d4a5.png";